/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DisableQuickbooksIntegrationInput = {
    realmId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type disableQuickbooksIntegrationMutationVariables = {
    input: DisableQuickbooksIntegrationInput;
};
export type disableQuickbooksIntegrationMutationResponse = {
    readonly disableQuickbooksIntegration: {
        readonly company: {
            readonly quickbooksEnabled: boolean | null;
        } | null;
    } | null;
};
export type disableQuickbooksIntegrationMutation = {
    readonly response: disableQuickbooksIntegrationMutationResponse;
    readonly variables: disableQuickbooksIntegrationMutationVariables;
};



/*
mutation disableQuickbooksIntegrationMutation(
  $input: DisableQuickbooksIntegrationInput!
) {
  disableQuickbooksIntegration(input: $input) {
    company {
      quickbooksEnabled
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisableQuickbooksIntegrationInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "disableQuickbooksIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableQuickbooksIntegrationPayload",
        "kind": "LinkedField",
        "name": "disableQuickbooksIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "disableQuickbooksIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableQuickbooksIntegrationPayload",
        "kind": "LinkedField",
        "name": "disableQuickbooksIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "disableQuickbooksIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation disableQuickbooksIntegrationMutation(\n  $input: DisableQuickbooksIntegrationInput!\n) {\n  disableQuickbooksIntegration(input: $input) {\n    company {\n      quickbooksEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '3faaedb8f68a6ad118573ad9a7f3c743';
export default node;
